import React from 'react';
import PropTypes from 'prop-types';
import { Container, Typography, Button } from '@sm/wds-react';
import { generateMetricsAttribute } from '@sm/metrics';
import { useTheme } from 'react-jss';
import classnames from 'classnames';

import useStyles from './useStyles';
import './product-callout-item.scss';

const ProductCalloutItem = ({ icon, heading, copy, href, utSource, cta, ctaColor, name, className, hideCTAs }) => {
  const theme = useTheme();
  const classes = useStyles({ theme, ctaColor });
  const containerClasses = classnames('sm-product-callout-item', 'wds-type--center', className);
  return (
    <Container
      flex
      flexDirection="column"
      flexJustify="center"
      pr={5}
      pl={5}
      pb={7}
      pt={7}
      data-testid="ProductCalloutItem"
      className={containerClasses}
    >
      <img alt="For You" src={icon} className="sm-product-callout-item__logo wds-m-b-5" />
      <Typography component="h3" color="light" variant="sectionTitle">
        <strong>{heading}</strong>
      </Typography>
      <Typography
        color="light"
        component="div"
        varient="body"
        className="sm-product-callout-item__copy wds-m-t-5 wds-m-b-5"
      >
        {copy}
      </Typography>
      <Choose>
        <When condition={hideCTAs} />
        <Otherwise>
          <Button
            size="lg"
            className={classes.smWebRespWebButton}
            href={href}
            data-sm-metric={generateMetricsAttribute({
              data: {
                actionType: `${utSource}_click_${name}_cta_to_sign_up`,
                actionFlow: { utSource },
              },
            })}
          >
            {cta}
          </Button>
        </Otherwise>
      </Choose>
    </Container>
  );
};

ProductCalloutItem.propTypes = {
  icon: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  copy: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  utSource: PropTypes.string.isRequired,
  cta: PropTypes.string.isRequired,
  ctaColor: PropTypes.oneOf(['sabaeus', 'concord', 'midnight']).isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  hideCTAs: PropTypes.bool,
};

ProductCalloutItem.defaultProps = {
  className: '',
  hideCTAs: false,
};

export default ProductCalloutItem;
